import QuickForm from "./src";
import type { App } from "vue";

QuickForm.install = function (Vue: App): void {
  console.info("QuickForm----install----");
  Vue.component(QuickForm.name, QuickForm);
};

export default QuickForm;
